module.exports = __webpack_public_path__ + "assets/img/e068461c9097ec5d9b4576934a31c1a9.svg";